const Order = { _class: 'Order', _collectionName: 'orders' };
const Slot = { _class: 'Slot', _collectionName: 'slots' };
const Answer = { _class: 'Answer', _collectionName: 'answers' };
const AnswerErrorReport = { _class: 'AnswerErrorReport' };
const AnswerComment = { _class: 'AnswerComment' };
const OSCE = { _class: 'OSCE', _collectionName: 'osces' };
const OSCEGroup = { _class: 'OSCEGroup', _collectionName: 'osce-groups' };
const OSCEText = { _class: 'OSCEText' };
const InstructionCategory = { _class: 'InstructionCategory' };
const Instruction = { _class: 'Instruction' };
const ILSProduct = { _class: 'ILSProduct', _collectionName: 'products' };
const AdornisFile = { _class: 'File', _collectionName: 'files' };
const ILSFile = { _class: 'ILSFile', _collectionName: AdornisFile._collectionName };
const ILSWebmFile = { _class: 'ILSWebmFile', _collectionName: AdornisFile._collectionName };
const ExamDay = { _class: 'ExamDay', _collectionName: ILSProduct._collectionName };
const ILSToken = { _class: 'SAMToken', _collectionName: 'samtoken' };
const ExamToken = { _class: 'ExamToken', _collectionName: ILSToken._collectionName };
const Appointment = { _class: 'Appointment', _collectionName: 'appointments' };
const OnlineStatus = { _class: 'OnlineStatus', _collectionName: 'online-status' };
const Counter = { _class: 'Counter', _collectionName: 'counter' };
const MailTemplate = { _class: 'MailTemplate', _collectionName: 'mail-templates' };
const AdornisEntity = { _class: 'AdornisEntity' };
const UserConfig = { _class: 'UserConfig', _collectionName: 'user-configs' };
const DataViewConfig = { _class: 'DataViewConfig', _collectionName: UserConfig._collectionName };
// ratings
const Score = { _class: 'Score', _collectionName: 'scores' };
const SlotScore = { _class: 'SlotScore' };
const ExamSlotGroup = { _class: 'ExamSlotGroup' };
const ExamSlotRating = { _class: 'ExamSlotRating' };
const ExamSlotFinalRating = { _class: 'ExamSlotFinalRating' };
const ExamSlotRatingDoc = { _class: 'ExamSlotRatingDoc', _collectionName: 'ratings' };
const ExamSlotFinalRatingDoc = {
  _class: 'ExamSlotFinalRatingDoc',
  _collectionName: ExamSlotRatingDoc._collectionName,
};
const AdornisUser = { _class: 'AdornisUser', _collectionName: 'adornisuser' };
const ILSUser = { _class: 'SAMUser', _collectionName: AdornisUser._collectionName };
const UserExportLine = { _class: 'UserExportLine', _collectionName: 'user-export-view' };
const RatingsExportLine = { _class: 'RatingsExportLine' };
const EventLog = { _class: 'EventLog', _collectionName: 'eventlog' };
const ReportedErrorDataviewLine = { _class: 'ReportedErrorDataviewLine' };
const ExamDayReservation = { _class: 'ExamDayReservation', _collectionName: 'examday-reservations' };
const CalendarEvent = { _class: 'CalendarEvent', _collectionName: 'calendar-events' };
const TimeSlot = { _class: 'TimeSlot', _collectionName: CalendarEvent._collectionName };
const EvaluationTermin = { _class: 'EvaluationTermin', _collectionName: CalendarEvent._collectionName };
const DateTimeDuration = { _class: 'DateTimeDuration' };
const Location = { _class: 'Location', _collectionName: 'locations' };
const Address = { _class: 'Address' };
const ZipCity = { _class: 'ZipCity' };
const InspectorOverviewLine = { _class: 'InspectorOverviewLine' };
const ILSUserOverviewLine = { _class: 'ILSUserOverviewLine' };
const ILSUserOverviewLineOrder = { _class: 'ILSUserOverviewLineOrder' };
const ILSUserOverviewLineExamDayCandidate = { _class: 'ILSUserOverviewLineExamDayCandidate' };

export const Names = {
  AdornisEntity,
  Order,
  Slot,
  Answer,
  AnswerErrorReport,
  AnswerComment,
  OSCE,
  OSCEGroup,
  OSCEText,
  InstructionCategory,
  Instruction,
  ILSProduct,
  ExamDay,
  RatingsExportLine,
  ExamSlotGroup,
  ILSToken,
  ExamToken,
  Appointment,
  OnlineStatus,
  MailTemplate,
  Counter,
  UserConfig,
  DataViewConfig,
  Score,
  SlotScore,
  ExamSlotRating,
  ExamSlotFinalRating,
  ExamSlotRatingDoc,
  ExamSlotFinalRatingDoc,
  AdornisUser,
  ILSUser,
  UserExportLine,
  EvaluationTermin,
  EventLog,
  AdornisFile,
  ILSFile,
  ILSWebmFile,
  ReportedErrorDataviewLine,
  ExamDayReservation,
  TimeSlot,
  CalendarEvent,
  DateTimeDuration,
  Location,
  Address,
  ZipCity,
  InspectorOverviewLine,
  ILSUserOverviewLine,
  ILSUserOverviewLineOrder,
  ILSUserOverviewLineExamDayCandidate,
};
